import { mapState, mapActions } from 'vuex';
import { SET_RECORD_BIND_EMAIL } from '@store/officialSupport';
import { validSupportEmail } from '@utiles/officialSupport';

export default {
  data() {
    return {
      visibleEmailSubscribeSheet: false, // 是否显示邮箱订阅弹窗
      loadingSubmit: false, // 提交按钮loading
      submitSuccessTip: '', // 提交成功提示
      email: '' // 绑定的邮箱
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      recordBindEmail: state => state.recordBindEmail
    })
  },
  methods: {
    ...mapActions(['bindEmail']),
    getInputEmail(val) {
      this.email = val;
    },
    validEmail() {
      if (validSupportEmail(String(this.email).trim())) {
        return true;
      } else {
        this.$toast(this.languages.inputValidEmail);
        return false;
      }
    },
    async submitBindEmail() {
      if (this.recordBindEmail || !this.validEmail()) {
        return Promise.reject();
      }
      const submitEmailParams = {
        email: this.email?.trim ? this.email.trim() : this.email,
        status: 1 // 1是绑定，2是解绑
      };
      try {
        const data = await this.bindEmail(submitEmailParams);
        this.$store.commit(SET_RECORD_BIND_EMAIL, this.email);
        return Promise.resolve(data);
      } catch (error) {
        console.log(error);
        return Promise.reject(error);
      }
    },
    async submitUnBindEmail() {
      if (!this.recordBindEmail) {
        return Promise.resolve();
      }
      const submitEmailParams = {
        email: this.email?.trim ? this.email.trim() : this.email,
        status: 2 // 1是绑定，2是解绑
      };
      try {
        const data = await this.bindEmail(submitEmailParams);
        this.$store.commit(SET_RECORD_BIND_EMAIL, '');
        return Promise.resolve(data);
      } catch (error) {
        console.log(error);
        return Promise.reject(error);
      }
    }
  },
  watch: {
    recordBindEmail: {
      immediate: true,
      handler(val) {
        if (val) {
          this.email = this.recordBindEmail;
        }
      }
    }
  }
};
